import { useResolvedLocale } from "features/i18n/useLocale";
import { useTimeZone } from "features/timezone/useTimeZone";
import { GuxDateTimeBeta } from "genesys-spark-components-react";
import { GuxTimeZoneIdentifier } from "genesys-spark-components/dist/types/i18n/time-zone/types";

export function DateTime({
    date,
    dateTimeFormatOptions = {
        dateStyle: "short",
        timeStyle: "short",
    },
}: {
    date: Date;
    dateTimeFormatOptions?: Intl.DateTimeFormatOptions;
}) {
    const locale = useResolvedLocale();
    const formattedDate = date.toLocaleString(locale, dateTimeFormatOptions);
    return <span>{formattedDate}</span>;
}

export function DateTimeWithTimeZone({ date }: { date: Date }) {
    const timeZone = useTimeZone();

    return (
        <GuxDateTimeBeta
            timeZone={timeZone as GuxTimeZoneIdentifier}
            datetime={date.toISOString()}
        />
    );
}
